// extracted by mini-css-extract-plugin
export default {"container":"BookmarkList_container__m8dn5","list":"BookmarkList_list__wW9wz"};